import React from 'react';
import Icon from '../atoms/Icon';

function On3Icon(props: any, ref: React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
        <image style={{overflow:"visible"}} width={props.width ? props.width : "1200"} height="2000" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATYAAACiCAMAAAD84hF6AAAAk1BMVEX///8cJSwZIyoWICjt7u8A
ExyWmZwdJi4ABRQPHCXm5ufJy8w7QUcQGyP6+vpiZ2snMDcADxqIjI9ITlJxdXlOVFnAw8Q/Rkqk
p6oACxcLGCGtr7EAABLz8/Tp6usvNz3Mzs/V19h/g4aeoaQAAA1ZXmONkZRnbHDb3N1yd3q2uLtU
Wl80O0FydnpLUVY8Q0kAAACBmRtOAAANAElEQVR4nO2d6WLivA6Gg00gBQKYPWGHUpZu3/1f3YH2
TKeS5SWJQ9Jp3p+lQPzgRZYl2fMqVapUqVKlSpUqVapUqVKlSpUqVfrl6iZS0U9bBq0mjePbSz+B
1u+H3fz0m+HV5wce+SHnLIE4D+PIfxlsi376gtTaNaOQ1dKJ+9HzpOgWFKDlk/DTMvtUGLxtim7F
vbV5EdmgfYDzB0W3475qLHhmaDdFw1bRTbmjzlH2rvapsPlrloZuL3IE7Sr+sCm6PXfSSLijduXG
f0d/ayxcUruO03W96CbdQZPALbVaLT4U3ab8tWy6WUO/K5oV3arctfOdU6sxf1V0s3LWKePWgJa/
K7pdOWsU50Ctxh5OiZ6iW29t25PLHOkyaW9b9RI6V1pxHp3t2t2sd1nL7Wx36DRjEURRJICufwhE
3Hx5Ps82yzwpJNbeqcn2V4zZ9JHutjGOr2RCrvnxGA+vTOO3xqY83W6Kl9Ew1sn39U38q4XZi3Qa
dIRv92k3eL7feUo29HNTC++q+OF1pNTr7mmw601ZJMxuudi0KEyeF35C04f7i0MpfHpzjC3YmN/U
Pc2PzcjQZD7VDqn2WxQmY/apMHpuO2p7Bu3wOhpYPlR9PhVacIxpTLdWL0gF7QNccCzcKBzjptti
u2oyDHRDNVJv6GcPmayemM1dtD29ui8ZsF2b39T0meii+tKjFreF2GJX6KK67OMGJMLmtZ7Vjjqh
2Je2pg52c+KtSCdLvZkNm+cNlO4TsSffsFqnntW+K54WyC07Nq+h6m9+g/r3lora7byVlGJAx+/F
cXOAzdsrnJwktuWUoMZCcd1CrafDsaTh+/q67RIxsWjH48LmNxfYvAG9PyOxHaV5jcWL5nHWPtXp
WJLudZPfnp37hGkszokf1ZGcYPMOpDlBYdvjmZD5zZ3VVnO760vnuEFRdogbbPU+ZfgS2E7Y3RIG
DesZajl7QF2VxQXZvW6weRdqWSCwPaOJTRwSnUUvR+g0N+6leFgHcoRN4kFju6DFI0oc+bBH3KJi
NvausG0I603ChrckEWmh6DWH5HnH+I7usu7cw+kKG9XdJGzI2+KnWgjRsr1Q7eA+VL/sxrcIx87h
yamL0xk2YnaTsL2DzsZfUjWkC3+gcKz+19OZB/FHhCMP/WCaYNmt94CkVcsZtuWDZMxjbO1H8LJI
6TbbwuVU7R9sCLBu82Bsvf60RPhX8YO0XsvYojYd72z6pp40SjG2M7DuwtSLIPwcpRP5VYqhivsb
y69ofe8EhONQxsZepqSGf9SjHRtzaauAsNWhs+XRtgmSTgAba9IT/o7Y8nEb1/VNybHVVDvqPwoX
a8r/uJUmN4RtAv6Bv9s1gNIBdGx6sE/IDR9v2h3hpMBmVsiJL18x/EkIG3S/K7xKVoIrMjlKu2va
YR/2rTYluWCrhcTpylLyEyNssCFxhpM70Ci6385U3qz4OfE3OMNGnYF2h3psK2AQ8/csZhT8KiEv
kF3p9PdL0ZPFF+SEjRoY0mEOxAaD6OJXe0iy4HgnfsO22lXPbAyfnLCFRNifAVsDmFtZpja8avty
/xloTitszOy8ettI+ibTID2C5c8i0kGjDcBG/IbSs3yXhQMhJ2yRvFExLQmwJUGmWI4WGKS8g7tP
F7YqhE/GYmNEdj7YWE1exg0GCDxZZHGm45MleGrWxB/Wgr2xh7zP4dD0BflgWxAbhY3e3IVGA+tn
8kd0DcYMML0ZX2IrLjBFFueCTcgz29VS0m+utuBl/pKUFBT0pYgNehn8hLclAK2srGnY1OeBLepR
XcWwlW8721rdhAw3vL60A/xdKKw7Puo/PwdsEdXXvLocywqwQX8cN84uer1BbHiBgthuDuAlQ45l
vfHmHBt/pD3ZJjfl3Ck2aCNKwSYyNvx8/EXrKHeNLe4rDK6xwSkOpz632CQ3MoHN68HVVGj3WG6x
8UD2D39KXkfLhg1FxDNfZzk6xRY3le54orOVDBsOiQ91rhCH2Lg4Km1UKQK4hNi6KGhnoTmScYdN
qGa1j08xBjMUjw3tZK/GmzoSwhU2LnaapccidKYE2CTjjbSkPuQIm7/WeSxsArXKgG2JInwelcab
G2zRSGflNB7pd5UOm3eBIRdqF7MTbKE2VqOhStoqHzbvaGm8ucAmO2a+qUudR5YWGzbehMJ4c4NN
s+SM1QmCJcSG47Mp5/5Hs/LFNueaYPkyYvPe4AMrwlhzxbbsLXTvLiW2DYqP65OLXc7YtElApcSG
jTc6yC7nQbqPf9og9ZZrC89b3kvC9l19IllObDiAmEx7zd0AWY6UOVclxSYZb4RV6sTcfdAe9Ci2
VuXFBg/RaoyI4nG0udJmbw5scq5KhM3bQ+ONSG5wtJUXnY2mEa/0/HY/bDigxICti4w3OV/YmeMo
Hqg7HH4MCpvbk6vkRzBAWzg+GMPGmzM3JYs0viM0W1DYUAjqNAEjQvCcVOotJmzeDs7HUkGmOznF
5SN5jA2e0Vgkr2gFo/6kiDUjNhznE23g6/c6gqGiFwG2E5j/MsaAeLDVPo4gMmLzJsh4Q543twd+
LDooLN+2KecKBiQxnikNqgvDlziO6DBjw8emEVxVnB8vNxU5TkQgHsCG0tSIeNsEqsPwpTX+DSyw
rWDD0bGp82AG9kjbcMSRHzSnYKrUYpMMFNQJWjNv+HULbDiPGhpvOYTOiAPFbSXXHITYYJgyEY6Z
QNCaiSUnhg02yfP2fRjlEajlv1ET08GQcwW7Y7bS4zB8Wi4faoVtCx3kwPOWS1igT7mSDWGByMTk
VlkVKsFYuoUUimuFDW+mxTfjLZ8g1IBwGhiCUL0unMY1ziijUBywnKtmhw0bb/7m66WcQp7lDEuv
JVWHQTtslGCWIcIeRmYSGZZ22LwJPOAN/25d8gqwl11J2GsqYYOjODSEgeqEkt7k1cUSG/a8BV/G
W15ZMHKjTekcKA20JlKPUlQFLJZNQFtsLWS81f58VHmShyS3hU3KGCkYqEYly9ti82Zwj/VlvOWE
jarhbMQGkxVTLwooAIayAK2xeUPa81aexEgpmDxdPQvPewKdjcz5tse2hVY6//8+Lac03KG8UZDL
NUq+anREGWhLeKjURq4yaqzbY0M/wh/jLZ+kbyrj3Jj0LRWGYixFvtoKDlFG+gQSYEMGAPt0QqXA
ZqgwwOPHKdXcrWGXcBPqbjz5ZTutFzgZCXKTlgAbziv6HEjJsfH3oV4jemzJLhAZG+6RnCUcp5s+
pMbpigFJsOEK/h8maXJshrQapY7G8imenPnPglECx1t9EKD585HGnggb9ryxVhpsaYv1yJU3qWqB
UnB03NxZznCtpz4+WFRlnCXC5s1lz9vdsNmUhvJudjleb5kvnhumyxCW2/3Bl2osctUFR8mw4VyU
xRymRxPBHM6wyXmRdEnPNnFRIL8SmR4H+/mE0Hw/OA6bQsifr07eTogNed5YfJl979dMjoFzhU0u
1aOquzsnQwlvpcJud3EQEj59QQNT230JsXlPKEsXhp8RAeWusBGdTYHtug9MtTGRqClLlifH5ilK
+3yK2IA7wjYx5lx900x/YYCduK+xXRJjowtJ/WmHbBu6wSb72nTYvHYz82VH+lJsibF5Z029FWID
7gabXLpZi+1W9z7TQFUfc38qOTb6h//8sgd5mXeCTZEHo8Z2C/rN0OF8fZxiGmzkCv8pKqPNBba5
Tc4VVussUoKL/bPJU5cCm7KgPJMiTDwn2Gaq30mL7WqzHIOkFw99mHhH8/4/DTZvR1fhElRVvezY
Gsppylg1qzVYB1RFfyWzOFgPbPawqbB5R4pbSJZwyHqpSb2nvtvUImBhOTn3rxsA8w1hV3NYiP7r
xC5QKR22LhH0TroWr//6jn/tRNgua80EZVfvu7vdHzsPQSBu17VRFUTj2/Yh7hz3W+uYuHTYbtVT
Ue0tsVb4GaTQjQTYtgftperC2gnZXW0v+8GoNx5KZWvHvdFgf9muEoURtv/7tjlbrO3fO+lEf6+L
436szHSX6urZYutOnn3tXTjaLJB8tWx/1ybBO7uXw8MiuN1VuQheNC4tXIvf6jI6bzXZrU3XonFN
te8ya7m9zPb7+US79qxwbwtHA40a+/3T7rD2I/MKSJ4p/TOSKvaHvk7iY+o2IbspffXrnyCyYIwD
8XXRLctVKc/ljcpWIrb8UmboZVKB6+h9lE93S3PPy8+SdGWXA/GMaS4/QUODBZZCWWJMf4pOZIJe
FkWm66r/CV0e3XKzu5Tg50t5x2g6agXeHHpfNdwcXn5S6xR+Effd5OTw8kNi/Fv62k2TWubDy5v4
4/nfNz2+q36MMnc4JtapAnJ/tCYdkw/NAM2Pd79pgH7pMha++TyEFI+jvtWx0j+p7dOQRyIOEyn2
I399vPzKnval1WS2G/US6HhuXOyPlSpVqlSpUqVKlSpVqlSpUqVKlSpVqpRe/wN5ahZ5fhC+ZwAA
AABJRU5ErkJggg==" transform="matrix(1 0 0 1 426 459)"></image>
    </Icon>
  )
}

export default React.forwardRef(On3Icon);